import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromHTML } from "draft-js";

const CkEditorFull = (props) => {
  const { form, field, label } = props;
  const [editorStateR, setEditorStateR] = useState(() => {
    // Initialize the editor state based on field.value
    if (field.value) {
      const blocksFromHTML = convertFromHTML(field.value);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  useEffect(() => {
    // Update the editor state if field.value changes
    if (field.value) {
      const blocksFromHTML = convertFromHTML(field.value);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorStateR(EditorState.createWithContent(contentState));
    }
  }, [field.value]);

  return (
    <div className="col-span-2 border p-2 min-h-60">
      <label className="leading-2">{label}</label>
      <Editor
        wrapperClassName="rdw-c-wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        editorState={editorStateR}
        onEditorStateChange={(editorState) => {
          setEditorStateR(editorState);

          // Convert the editor content to HTML and update Formik field value
          const rawContentState = convertToRaw(editorState.getCurrentContent());
          const htmlContent = draftToHtml(
            rawContentState,
            {},
            false,
            ({ type, data }) => {
              if (type === "IMAGE") {
                const alignment = data.alignment || "none";
                const textAlign = alignment === "none" ? "center" : alignment;

                return `
                <p style="text-align:${textAlign};">
                  <img src="${data.src}" alt="${data.alt}" style="height: ${data.height}; width: ${data.width};" />
                </p>
              `;
              }
            }
          );

          form.setFieldValue(field.name, htmlContent);
        }}
      />
    </div>
  );
};

export default CkEditorFull;
